import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import AdminNavigation from './AdminNavigation'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import './../../teams/pages/TeamForm.css'

const UpdateAllTeamJerseyNumbers = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [rosterPlayers, setRosterPlayers] = useState([])
	const [numbersByRosterPlayerId, setNumbersByRosterPlayerId] = useState({})

	const navigate = useNavigate()
	const errorHandler = () => setError(null)

	const { leagueName, year, divisionId, teamName } = useParams()

	useEffect(() => {
		const fetchRoster = async () => {
			try {
				setIsLoading(true)

				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL +
						`/admin/rosterPlayers/${leagueName}/${year}/${divisionId}/${encodeURIComponent(
							teamName,
						)}`,
				)

				let data = null
				try {
					data = await response.json()
				} catch (e) {
					data = null
				}

				if (!response.ok) {
					throw new Error(data?.message || 'Could not load roster players')
				}

				const loaded = data?.rosterPlayers || []
				setRosterPlayers(loaded)

				const map = {}
				loaded.forEach((rp) => {
					map[rp._id] = rp.number ?? '00'
				})
				setNumbersByRosterPlayerId(map)

				setIsLoading(false)
			} catch (err) {
				setIsLoading(false)
				setError(err.message || 'Something went wrong loading roster players')
			}
		}

		fetchRoster()
	}, [leagueName, year, divisionId, teamName])

	const onNumberChange = (rosterPlayerId, value) => {
		setNumbersByRosterPlayerId((prev) => ({ ...prev, [rosterPlayerId]: value }))
	}

	const submitHandler = async (event) => {
		event.preventDefault()

		try {
			setIsLoading(true)

			const updates = rosterPlayers.map((rp) => ({
				rosterPlayerId: rp._id,
				number: (numbersByRosterPlayerId[rp._id] ?? '00').toString().trim(),
			}))

			const response = await fetch(
				process.env.REACT_APP_BACKEND_URL +
					`/admin/updateAllJerseyNumbers/${divisionId}/${leagueName}/${year}/${encodeURIComponent(
						teamName,
					)}`,
				{
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ updates }),
				},
			)

			let data = null
			try {
				data = await response.json()
			} catch (e) {
				data = null
			}

			if (!response.ok) {
				throw new Error(data?.message || 'Could not update jersey numbers')
			}

			setIsLoading(false)

			navigate(`/admin/${leagueName}/${year}/${divisionId}/${teamName}/players`)
		} catch (err) {
			setIsLoading(false)
			setError(err.message || 'Something went wrong saving jersey numbers')
		}
	}

	return (
		<React.Fragment>
			<ErrorModal error={error} onClear={errorHandler} />
			{isLoading && <LoadingSpinner asOverlay />}
			<AdminNavigation />

			<main>
				<h2>Bulk Edit Jersey Numbers</h2>
				<h3 style={{ textAlign: 'center' }}>{teamName}</h3>

				{/* <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
					<button
						className='okbutton cancelDeleteButtons'
						onClick={() =>
							navigate(
								`/admin/${leagueName}/${year}/${divisionId}/${teamName}/players`,
							)
						}
					>
						Cancel
					</button>
				</div> */}

				<form onSubmit={submitHandler}>
					<div className='Players' style={{ marginTop: '1rem' }}>
						<table id='players'>
							<thead>
								<tr>
									<th>Player Name</th>
									<th>Number</th>
								</tr>
							</thead>
							<tbody>
								{rosterPlayers.map((rp) => (
									<tr key={rp._id}>
										<td style={{ textAlign: 'center' }}>
											{rp.firstName} {rp.lastName}
										</td>
										<td style={{ textAlign: 'center' }}>
											<input
												style={{ width: '70px', textAlign: 'center' }}
												value={numbersByRosterPlayerId[rp._id] ?? ''}
												onChange={(e) => onNumberChange(rp._id, e.target.value)}
												maxLength={3}
											/>
										</td>
									</tr>
								))}
							</tbody>
						</table>

						<div
							style={{
								textAlign: 'center',
								marginTop: '2rem',
								marginBottom: '5rem',
							}}
						>
							<button className='okbutton uploadButton' type='submit'>
								Save All Numbers
							</button>
						</div>
					</div>
				</form>
			</main>
		</React.Fragment>
	)
}

export default UpdateAllTeamJerseyNumbers
